import React from 'react';
import { FormattedMessage } from 'react-intl';

import MainFooter from 'components/Core/Footer/MainFooterSection/MainFooter';
import { getTxnTextBasedOnType } from 'shared/utils';
import { colors, fontSize, breakpoints } from 'styles/cp';

interface EstimateFooterProps {
  isChangeOrder?: boolean;
}
const EstimateFooter: React.FC<EstimateFooterProps> = ({ isChangeOrder }) => {
  const { Transactions_text } = getTxnTextBasedOnType(isChangeOrder);
  const Transactions = (
    <FormattedMessage
      id={Transactions_text}
      defaultMessage={Transactions_text}
      values={{ transaction: Transactions_text }}
    />
  );
  return (
    <>
      <hr className="footer-separator" />
      <div className="footer">
        <div className="footer-legal">
          <FormattedMessage
            id="ESTIMATE_PENDING_LEGAL_MESSAGE"
            defaultMessage="{Transactions} are subject to change. The business will reach out to confirm final details."
            values={{ Transactions }}
          />
        </div>
        <MainFooter withTOS={true} separator={' '} />
      </div>
      <style jsx>{`
        .footer-separator {
          border: solid 1px ${colors.gray06};
          margin: 0 0 8px;
          @media screen and (max-width: ${breakpoints.md}) {
            display: none;
          }
        }

        .footer {
          .footer-legal {
            font-family: AvenirNextforINTUIT-Regular;
            font-size: ${fontSize.xxs};
            text-align: center;
            color: ${colors.ghostGray};
          }
        }
      `}</style>
    </>
  );
};

export default EstimateFooter;
